import moment from 'moment';

const addWeekDays = (date, days) => {
  let i = days;
  const mDate = moment.utc(date);

  while (i !== 0) {
    const amount = days > 0 ? 1 : -1;
    mDate.add(amount, 'days');

    if (mDate.isoWeekday() !== 6 && mDate.isoWeekday() !== 7) {
      i -= amount;
    }
  }

  return mDate;
};

export default addWeekDays;
